import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const AboutAstrologer = ({language}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  
  useEffect(() => {
    const img = new Image();
    img.src = "/image/bg/astro2bg.webp"; // Ensure correct path
    img.onload = () => setImageLoaded(true);
  }, []);

  return (
    <div className="relative mt-28 sm:mt-12 min-h-screen flex flex-col items-center justify-center text-white p-8">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed transition-opacity duration-500"
        style={{
          backgroundImage: imageLoaded ? "url('/image/bg/astro2bg.webp')" : "none",
          opacity: imageLoaded ? 1 : 0,
        }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-yellow-600 bg-opacity-60"></div>
      <Helmet>
        <title>Pt. Akhileshwar Sharma - Astro-MahaMaya</title>
        <meta
          name="description"
          content="हम क्षेत्र के सर्वश्रेष्ठ ज्योतिषी की सहायता से एक व्यापक ज्योतिष मार्गदर्शन सेवा प्रदान करते हैं..."
        />
      </Helmet>

      {/* Content */}
      <div className="relative z-10 max-w-3xl bg-yellow-100 bg-opacity-80 p-6 rounded-lg shadow-lg text-center mt-20">
        <img
          src="/image/AkhileshwerSharma.png"
          alt="Astrologer Akhileshwar Sharma"
          className="w-40 h-48 rounded-full mx-auto border-4 border-yellow-400 shadow-lg"
        />
        <h1 className="text-3xl font-extrabold text-black mt-4">
          Mr. Akhileshwar Sharma
        </h1>
        <p className="text-lg font-semibold text-gray-800 mt-2">
          Qualification: Double M.A. in Jyotish
        </p>

        

        {/* Hindi Content */}
        {language === "hindi" && (
          <>
          <p className="mt-6 text-gray-600 leading-relaxed text-lg">
          
          ज्योतिषाचार्य पं. अखिलेष शर्मा का जन्म सन् 1970 में एक बा्रह्मण परिवार में षिक्षक स्व. श्री आषारामजी के यहॉं हुआ। नानाजी श्रद्धेय स्व. श्री पं.रामचंद्र शर्मा मध्यप्रदेष के मंदसौर जिले के प्रख्यात ज्योतिषी थे। बचपन से मिले नानाजी के इस सान्निध्य ने ज्योतिष के नये-नये सूत्र इन्हें विरासत में दिये। वंष परम्परा से मिले इस ज्ञान के बावजूद भी ज्योतिष के ज्ञानार्जन की उनकी यात्रा सतत रुप से चलती रही। बचपन से हर कक्षा में अव्वल रहते हुऐ विज्ञान विषय चुन कर बी.एससी. की उपाधि अच्छे अंकों से उत्तीर्ण की। इसके पश्चात सेना में कमीषन्ड अधिकारी पद के लिये होने वाली कठिन परीक्षा भी उत्तीर्ण कर ली लेकिन पिता के असामयिक निधन ने जीवन की दिषा ही बदल दी। कुण्डली की ग्रह स्थिति ज्योतिष की सेवा के लिये प्रेरित कर रही थीं और ये स्वतः ही उनकी आजीविका बन गया। उनके मुंह से निकलने वाला हर शब्द सत्य होता चला गया। ज्योतिषी के रुप में सेवा देते हुए आपने ज्योतिष तथा संस्कृत दोनों ही विषयों में स्नातकोत्तर एम.ए. की उपाधि भी विक्रम विष्वविद्यालय उज्जैन से प्राप्त की। इन परीक्षाओं में आचार्यजी ने विष्वविद्यालय की प्रावीण्य सूची में स्थान प्राप्त किया। इसके साथ ही उन्होने देष के ख्यात पत्र-पत्रिकाओं के लिये लेखक के रुप में लेखन भी किया। आप भारतीय ज्योतिष के साथ ही प्रष्नषास्त्र, अंक ज्योतिष, तथा वास्तु के सिद्धहस्त विद्वान हैं।
          </p>
          <p className="mt-6 text-gray-600 leading-relaxed text-lg">
            
          हम क्षेत्र के सर्वश्रेष्ठ ज्योतिषी की सहायता से एक व्यापक ज्योतिष मार्गदर्शन सेवा प्रदान करते हैं, जिन्होंने कई पुस्तकें लिखी हैं। श्री शर्मा, हमारे अनुभवी सलाहकार और ज्योतिषी, 2000 से अभ्यास कर रहे हैं। हमारे निर्बाध दृष्टिकोण के साथ, हम यह सुनिश्चित करते हैं कि ज्योतिषीय मार्गदर्शन चाहने वाले व्यक्तियों को उच्चतम गुणवत्ता की अंतर्दृष्टि और समर्थन प्राप्त हो। चाहे आप विशिष्ट प्रश्नों के उत्तर ढूंढ रहे हों या ज्योतिष की गहरी समझ प्राप्त करना चाहते हों, श्री शर्मा की विशेषज्ञता और व्यापक ज्ञान आपको वह स्पष्टता और दिशा प्रदान करेगा जिसकी आपको आवश्यकता है। ज्योतिष की जटिलताओं को नेविगेट करने और आपके जीवन की यात्रा के लिए इसमें निहित ज्ञान को अनलॉक करने के लिए हमारे विश्वसनीय मार्गदर्शन पर भरोसा करें।
          </p>
          </>
        )}

        {/* English Content */}
        {language === "english" && (
          <>
           <p className="mt-4 text-gray-600 leading-relaxed text-lg">
        We offer a comprehensive astrology guidance service with the assistance of the best astrologer in the field, who has authored several books. Mr. Sharma, our experienced advisor and astrologer, has been practicing since 2000. With our seamless approach, we ensure that individuals seeking astrological guidance receive the highest quality insights and support. Whether you are looking for answers to specific questions or seeking a deeper understanding of astrology, Mr. Sharma's expertise and extensive knowledge will provide you with the clarity and direction you need. Trust our reliable guidance to navigate the complexities of astrology and unlock the wisdom it holds for your life's journey.
        </p>
        <p className="mt-4 text-gray-600 leading-relaxed text-lg">
        Pt. Akhilesh Sharma was born in 1970 in a Brahmin family of Shri Late Asharamji, a teacher. His grandfather (maternal) Respected (Late) Shri Pt. Ramchandra Sharma was a renowned astrologer in Mandsaur district of Madhya Pradesh. He got conversant with new aphoristic formulas, in heredity, under his grandfather’s care. Besides this specialized knowledge, he went on acquiring new skills of astrology. He maintained top position in all classes and got B.Sc. with good marks. After clearing tough exams, he was selected for commissioned in the Army, but his father’s untimely demise changed the course of his life. The planetary conditions in his horoscope were inspiring him to become an astrologer which itself made his livelihood. Every word from his mouth proved to be true. Serving as an astrologer he obtained post-graduate Degree in Astrology and Sanskrit language from Vikram University Ujjain. He was placed in the Merit List in both the Examinations. He started contributing articles as a writer in reputed Nation News papers and Magazines. Besides the Indian Astrology, he is an expert Question discipline, Numerical Astrology and Vedic Architectural knowledge (Vastu). His wife Dr. Pragya Sharma is his helping hand as an expert in Palmistry. 
        </p>
          </>
        )}

        {/* Contact Button */}
        <div className="mt-8">
          <p className="text-lg sm:text-xl text-yellow-800 font-semibold">
            For guidance, meet our astrologer
          </p>
          <Link to="/contact">
            <button
              className="mt-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-6 rounded-full shadow-lg transition-all duration-300 text-lg"
              onClick={scrollToTop}
            >
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutAstrologer;







